import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function getNavigation(handle:string): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('navigation')
    .setMethod('GET')
    .setProps([{handle: handle}])
    .send();
}
